const VERSION = "6.0.0";
export {
  VERSION
};
